module.exports = __webpack_public_path__ + "static/media/OpenSans-Regular.55835483.woff2";